module.exports = __webpack_public_path__ + "assets/img/main_img_half_bottom.3564f99a.svg";